module.exports = "/_next/static/images/ourPartnersWyyerdLogo-a07391808ae6ebf60660bdb148e3ea5c.webp";